var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_880_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 20.6668C16.1667 19.7828 16.5179 18.9349 17.1431 18.3098C17.7682 17.6847 18.616 17.3335 19.5001 17.3335H29.5001C30.3841 17.3335 31.232 17.6847 31.8571 18.3098C32.4822 18.9349 32.8334 19.7828 32.8334 20.6668V27.3335C32.8334 28.2176 32.4822 29.0654 31.8571 29.6905C31.232 30.3156 30.3841 30.6668 29.5001 30.6668H19.5001C18.616 30.6668 17.7682 30.3156 17.1431 29.6905C16.5179 29.0654 16.1667 28.2176 16.1667 27.3335V20.6668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8333 21.5L26.9999 24L22.8333 26.5V21.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_880_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14.5 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterCircle);
export default __webpack_public_path__ + "static/media/twitter-circle.ea8b294db6fc52c5fca6ecf21ca81fbc.svg";
export { ForwardRef as ReactComponent };